import { openDB } from "idb"

export const DB_NAME = "app-store"
export const DB_VERSION = 14

export const STORES = {
  PATIENTS: "patients",
  PROFILE: "profile",
  CONSULTATIONS: "consultations",
  APPOINTMENTS: "appointments",
  MEDICINE: "medicine",
  JUSTIFICATIONS: "justifications",
  LETTRES_ORIENTATION: "lettres_orientation",
  CERTIFICATS: "certificats_medicaux",
  ARRETS_TRAVAIL: "arrets_travail",
  BILANS: "bilans",
  PRESCRIPTIONS: "Prescriptions",
  OUTBOX: "outbox",
  GENRES: "genresM",
  QSP: "qspM",
  TESTS: "testsB",
  PRESTATIONS: "prestations",
  PAYMENTS: "payments",

  WAITING_LIST: "waiting_list",
  REMINDERS: "reminders",
  USERS: "users",
  EXPENSES: "expenses",
}
export function isOnline() {
  return localStorage.getItem("isOffline") !== "true"
}
// Connexion ouverte, mémorisée pour pouvoir la fermer si une autre instance
// (autre onglet) veut faire une montée de version : sinon l'upgrade reste
// "blocked" et la promesse ne se résout jamais → tout lecture offline gèle.
let _openedDb = null

const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    Object.values(STORES).forEach((store) => {
      if (!db.objectStoreNames.contains(store)) {
        db.createObjectStore(store, { keyPath: "id" })
      }
    })
  },
  blocked() {
    // Une ancienne connexion (autre onglet) empêche notre upgrade.
    // On ne peut pas la fermer d'ici, mais on évite de pendre : la résolution
    // se fera dès que l'autre onglet se ferme ou exécute son `blocking`.
  },
  blocking() {
    // Une nouvelle version veut s'ouvrir ailleurs et NOUS la bloquons :
    // on ferme notre connexion pour la laisser passer.
    try {
      _openedDb?.close()
    } catch (_e) {
      // best-effort
    }
  },
  terminated() {
    _openedDb = null
  },
}).then((db) => {
  _openedDb = db
  return db
})

export function writeData(store, data) {
  return dbPromise.then((db) => {
    const tx = db.transaction(store, "readwrite")
    tx.store.put({
      ...data,
      // Préserve la chronologie réelle : si l'enregistrement vient du serveur
      // avec un `creationDate`, on l'utilise pour `createdAt` au lieu de
      // stamper l'heure de la sync (ce qui cassait le tri par date).
      createdAt:
        data.createdAt ?? data.creationDate ?? new Date().toISOString(),
    })
    return tx.done
  })
}

export function writeBulkData(store, items = []) {
  return dbPromise.then((db) => {
    const tx = db.transaction(store, "readwrite")
    items.forEach((item) =>
      tx.store.put({
        ...item,
        createdAt: item.createdAt ?? Date.now(),
      }),
    )
    return tx.done
  })
}

const getTimestamp = (item) => {
  const dateStr = item.createdAt || item.creationDate
  return dateStr ? new Date(dateStr).getTime() : 0
}

export function readAllData(store) {
  return dbPromise.then(async (db) => {
    // Si le store n'existe pas encore (DB partiellement migrée), renvoyer []
    // plutôt que de jeter une exception qui figerait la page.
    if (!db.objectStoreNames.contains(store)) {
      return []
    }
    const data = await db.getAll(store)
    return data.sort((a, b) => getTimestamp(b) - getTimestamp(a))
  })
}

export function clearAllData(store) {
  return dbPromise.then((db) => {
    const tx = db.transaction(store, "readwrite")
    tx.store.clear()
    return tx.done
  })
}

export function deleteItemFromData(store, id) {
  return dbPromise.then((db) => {
    const tx = db.transaction(store, "readwrite")
    tx.store.delete(id)
    return tx.done
  })
}
